import React, { useState, lazy } from 'react';
import styles from '../styles/travelSafety.module.css';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PhoneVerificationComponent = lazy(() => import('../../../components/sharedComponents/PhoneVerification'));


const TravelSafetyHero = () => {

    const isAboveMediumScreens = useMediaQuery("(min-width: 500px)");

    const [toggleSearchInput, setToggleSearchInput] = useState(true);

    const togglePhoneVerificationPopup = (e) => {
        e.preventDefault();
        setToggleSearchInput(!toggleSearchInput);
    }

    return (
        <section>
            <div className={styles.heroBgImage}>
                <div className={styles.homeHeroInnerContainer}>
                    <div className='maxScreen'>
                        {!isAboveMediumScreens && <div className={styles.emptyContainer}></div>}
                        <div className={styles.heroContainer}>
                            <h1 className={styles.heading}><span className="hightLightText">Make Every Adventure</span>
                                <br></br>A Great One With <br></br>The World’s #1 Travel Safety App</h1>
                            <p className={styles.paragraph}>
                                Traveling is about freedom, exploration, and unforgettable experiences, but you always need a safety net. Device Tracker Plus keeps you connected, safe, and worry-free. Share your real-time location with trusted friends and family so they always know where you are, even when you're miles apart.  </p>
                            <div className='inputContainer'>
                                {toggleSearchInput && <PhoneVerificationComponent showPopUp={togglePhoneVerificationPopup} />}
                            </div>

                        </div>
                        <div className={styles.emptyContainer}></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default TravelSafetyHero;